
import moment from 'moment';

export default ({
  date, numbers, type,
}) => moment(date).subtract(numbers, type).format();
